/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState, useRef } from "react";

import Modal from "./Modal";
import ProgressBar from "components/UpgradeSkills/ProgressBar";
import ButtonGroup from "components/UpgradeSkills/ButtonGroup";
import { ClOSE, MODAL_CLOSE, SHOES, SUIT, CIGAR } from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";
import * as icon from "services/icon";

const image = (name) => {
  switch (name) {
    case "Shooting":
      return SHOES.SOURCE;

    case "Racketeering":
      return SUIT.SOURCE;

    case "Patience":
      return SHOES.SOURCE;

    case "Intelligence":
      return SUIT.SOURCE;

    case "Gambling":
      return CIGAR.SOURCE;

    default:
      return CIGAR.SOURCE;
  }
};

const StatData = ({ name }) => (
  <div className="d-flex stats-data mb-2">
    <p className="skills-name mt-1 ">{name}</p>
  </div>
);

const SkillUpgradeModal = ({
  isVisible,
  address,
  onClose,
  handleUpgradeSkill,
  nftData,
  nftId,
  gbetInWallet,
}) => {
  const [skillsObj, setSkillsObj] = useState({});

  const [userValue, setUserValue] = useState({});
  const [checkValue, setCheckValue] = useState(false);
  const [breakdownTotal, setBreakdownTotal] = useState(0);

  const { skills, currentExpPercent, levelTitle, nextLevelTitle } = nftData;
  console.log(gbetInWallet);
  const progressRef = useRef(null);
  const progressRefEst = useRef(null);

  useEffect(() => {
    if (isEmpty(skills)) return;
    const skillsObjHelper = {};

    Object?.keys(skills).map((key) => {
      const skillName = skills[key][0];

      skillsObjHelper[skillName] = skills[key][1];
    });
    // skills.map((skl) => {
    //   const skillName = Object.keys(skl);

    //   skillsObjHelper[skillName] = Object.values(skl);
    // });
    setSkillsObj(skillsObjHelper);
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    const value =
      parseInt(nftData.currentExp) / parseInt(nftData?.nextLevelExp);

    progressRef.current.style.width = replaceFloatValue(value * 100) + "%";

    const estProgress =
      (parseInt(breakdownTotal.skill) + parseInt(nftData.currentExp)) /
      parseInt(nftData?.nextLevelExp);

    progressRefEst.current.style.width =
      replaceFloatValue(estProgress * 100) + "%";
  }, [isVisible]);

  const getSkill = () => {
    const skills = {};
    let total = 0;
    Object.entries(userValue).map(([key, value], index) => {
      if (value[[0]]) {
        skills[index + 1] = value[0];
        total = total + Number(value[0]);
      }
    });

    setBreakdownTotal((prev) => {
      return {
        total: prev?.total ? prev.total : 0,
        skill: total,
      };
    });

    return { skills, total };
  };

  const checkPreviewData = async () => {
    const { total, skills } = getSkill();
    const response = await icon.getSkillChangeCost(nftId, total);
    setBreakdownTotal((prev) => {
      return {
        ...prev,
        total: response?.totalCost,
      };
    });
  };

  const upgradeSkill = async () => {
    handleUpgradeSkill(getSkill());
  };

  function isEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }

    return true;
  }

  useEffect(() => {
    if (isEmpty(skillsObj)) return;
    console.log("skillsObj n", skillsObj);
    Object.entries(skillsObj).map(([key, value]) => {
      setUserValue((prev) => {
        return {
          ...prev,
          [key]: [0],
        };
      });
    });
    setCheckValue(true);
  }, [skillsObj]);

  useEffect(() => {
    if (isEmpty(userValue)) return;
    checkPreviewData();
  }, [userValue]);

  const calculateSkillPercentage = () => {
    const value =
      parseInt(nftData.currentExp) / parseInt(nftData?.nextLevelExp);

    return replaceFloatValue(value * 100) + "%";
  };

  const checkConfirm = () => {
    if (isEmpty(userValue)) return false;

    const value = Object.values(userValue);
    const res = value.reduce((a, b) => Number(a) + Number(b));

    return res <= 0;
  };

  useEffect(() => {
    if (!isVisible) return;
    const value =
      (parseInt(breakdownTotal.skill) + parseInt(nftData.currentExp)) /
      parseInt(nftData?.nextLevelExp);

    progressRefEst.current.style.width = replaceFloatValue(value * 100) + "%";
  }, [breakdownTotal.skill]);
  return (
    <Modal
      overlayClass="overlay"
      className="upgrade-skill-modal card px-3 py-4 bg-dark-modal"
      isVisible={isVisible}
    >
      <div className="header px-0 px-md-3 pb-2">
        <div className=" d-flex justify-content-between">
          <h4>Upgrade Skill</h4>
          <span
            onClick={() => onClose()}
            onKeyPress={(e) => e.code == "Enter" && onClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </span>
        </div>
        <div className="w-100 w-sm-75 d-flex justify-content-between flex-column flex-sm-row align-items-center mb-2">
          <div className="current-stats d-flex">
            <p className="name">Current Stats</p>
            <p className="value ps-2">
              <strong>{parseInt(nftData.currentExp)}</strong>
              <span className="ms-2">(total)</span>
            </p>
          </div>
        </div>
        <div className="stat mt-1 d-flex justify-content-between align-items-center">
          <div className="w-100 mb-2">
            <div className="progress-value d-flex justify-content-between px-2">
              <p className="first mb-0 d-flex justify-content-between">
                <span>{parseInt(nftData.currentExp)}</span>
                <span>{calculateSkillPercentage()}</span>
              </p>
              <p className="second mb-0 d-flex justify-content-between">
                <span></span>
                <span>{parseInt(nftData?.nextLevelExp)}</span>
              </p>
            </div>
            <div class="progress upgrade-bar position-relative">
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "0%" }}
                ref={progressRef}
              />
              <div
                class="progress-bar estimated"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "0%" }}
                ref={progressRefEst}
              />
            </div>

            <div className="role d-flex justify-content-between">
              <span>{levelTitle}</span>
              <span>{nextLevelTitle}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="body px-0 px-md-3">
        {checkValue &&
          Object.entries(skillsObj).map(([key, value]) => {
            return (
              <div
                className="bar my-3 d-flex flex-column flex-md-row align-items-md-center"
                key={key}
              >
                <StatData name={key} />
                <ProgressBar
                  progressValue={value}
                  userValue={userValue}
                  setUserValue={setUserValue}
                  keyword={key}
                />
                <ButtonGroup
                  onIncrement={() =>
                    setUserValue((prev) => {
                      const skill = `${key}`;
                      return {
                        ...prev,
                        [skill]: [prev[key][0] + 1],
                      };
                    })
                  }
                  increaseDisabled={100 - value <= userValue[key][0]}
                  decreaseDisabled={userValue[key][0] <= 0}
                  onDecrease={() =>
                    setUserValue((prev) => {
                      const skill = `${key}`;

                      return {
                        ...prev,
                        [skill]: [prev[key][0] - 1],
                      };
                    })
                  }
                />
              </div>
            );
          })}
      </div>
      <div className="wallet-info pt-0 pb-1 px-0">
        <div className="mb-3">
          <span>Wallet :</span>{" "}
          <strong>{gbetInWallet?.toFixed(4)} $GBET</strong>
        </div>
      </div>
      <div className="upgrade-button d-flex flex-column align-items-center">
        <button
          className="btn btn-primary"
          disabled={checkConfirm()}
          onClick={upgradeSkill}
        >
          Preview
        </button>

        {breakdownTotal.total ? (
          <span className="mt-2 helper-text">
            It will cost{" "}
            <span
              style={{
                color: `${
                  gbetInWallet < Math.round(breakdownTotal.total)
                    ? "#d21b59"
                    : "var(--black)"
                }`,
              }}
            >
              {" "}
              {Math.round(breakdownTotal.total)} $GBET
            </span>{" "}
            to update {breakdownTotal.skill} stats.
          </span>
        ) : (
          ""
        )}
      </div>
    </Modal>
  );
};

export default SkillUpgradeModal;
